import { Maybe } from '@/app/graphql/generated'

export const getTypeBtn = (id: Maybe<string> | undefined) => {
  switch (id) {
    case '1': {
      return 'secondary'
    }
    case '2': {
      return 'success'
    }
    case '3': {
      return 'warning'
    }
    default: {
      return 'primary'
    }
  }
}
